module.exports = __webpack_public_path__ + "src/assets/games/48/fengzheng.png";